// extracted by mini-css-extract-plugin
module.exports = {"root":"Dashboard_root__1nQGA","body":"Dashboard_body__2MiGj","sections":"Dashboard_sections__1fKkK"};